import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { TopicSidebarLoadAction } from '../../domains/topicSidebars/actions.types';
import { TopicEditAction } from '../../domains/topics/editActions.types';

import { TopicDescriptions } from './types';

export type TopicDescriptionsAction = TopicSidebarLoadAction | TopicEditAction;

const initialState: TopicDescriptions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TopicDescriptions, TopicDescriptionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPIC_SIDEBAR.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicDescriptions);
    case 'TOPIC.EDIT_FULFILLED':
      return update(state, action.payload.topicId, { description: action.payload.topic.description });
    default:
      return state;
  }
};

export default reducer;
